module.exports = __webpack_public_path__ + "img/e3.16bb81fb.svg";